// AllApps.js
import React, { useState, useReducer, useEffect, useMemo } from "react";
// import "./AllApps.css";
import allAppStyle from "./AllApps.module.css";
import { IoMdAdd } from "react-icons/io";
import { RiSearchLine, RiAddCircleLine, RiDeleteBinLine } from "react-icons/ri";
import { TbCategory } from "react-icons/tb";
import { FaList } from "react-icons/fa6";
import { TOGGLE_VIEW } from "../Reduceres/Action";
import { reducer, initialState } from "../Reduceres/reducer";
import PaginationPage from "../ReuseableComp/Pagination";
import { Link } from "react-router-dom";
import DownloadAndInstructions from "../CreateAppFlowC/DownloadAndInstructions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LoaderComp from "../LoaderComp";
import { ModalReuse } from "../ModalReuse";
import { IoTrashBin } from "react-icons/io5";
import modalStyles from "../ModalRes.module.css";
import AlertPopup from "../AlertPopup";

// ============================================================
// IMPORT FEATURE FLAGS
// ============================================================
import { isFeatureEnabled } from "../../config/featureFlags";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

export default function AllApps() {
  const [users, setUsers] = useState(null);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [searchTerm, setSearchTerm] = useState("");
  const [formValues, setFormValues] = useState({
    app_name: "",
    tenant_id: "",
    settings: {
      request_locally_managed: false,
    },
    displayMode: "desktop",
  });

  const [ShowInstructionsComponent, setShowInstructionsComponent] =
    useState(false);

  const [modalData, setModalData] = useState({
    isOpen: false,
    content: null,
    onConfirm: null,
    hideCloseButton: false,
  });

  const [alertData, setAlertData] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });

  const token = localStorage.getItem("token");

  const fetchUsers = async () => {
    const headersList = {
      Accept: "*/*",
      "User-Agent": "Thunder Client (https://www.thunderclient.com)",
      Authorization: token,
    };

    try {
      const regions =
        process.env.REACT_APP_STAGE_ENV == "dev" ? ["us"] : ["us", "in"];
      console.log("regiondds", regions);
      let allUsers = [];

      for (const region of regions) {
        try {
          let response = await fetch(
            `https://${region}.apps2.${backend_api_base_url}/all_apps`,
            {
              method: "GET",
              headers: headersList,
            },
          );
          let data = await response.json();

          if (Array.isArray(data)) {
            const regionData = data.map((app) => ({ ...app, region }));
            allUsers = [...allUsers, ...regionData];
          }
        } catch (regionError) {
          console.warn(`Failed to fetch from ${region} region:`, regionError);
        }
      }

      setUsers(allUsers.length > 0 ? allUsers : []);
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    }
  };

  const history = useHistory();

  const closeModal = () => {
    setModalData((prev) => ({ ...prev, isOpen: false }));
  };

  const showMessage = (message, type = "success") => {
    setAlertData({
      isVisible: true,
      type: type,
      message: message,
    });
  };

  const confirmDelete = async (appName, version, region) => {
    closeModal();

    try {
      const region_suffix = region.toLowerCase();

      const url = `https://${region_suffix}.apps2.${backend_api_base_url}/delete_app?app_name=${encodeURIComponent(
        appName,
      )}&version=${encodeURIComponent(version)}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        let errMsg = "Failed to delete app";

        try {
          const data = await response.json();
          errMsg = data.error || JSON.stringify(data);
        } catch {
          errMsg = await response.text();
        }

        showMessage(errMsg);
        return;
      }

      const data = await response.json();
      showMessage(`App "${appName}" deleted successfully`);
      fetchUsers();
    } catch (err) {
      console.error("Delete error:", err);

      let userMessage = "Unexpected error while deleting app";

      if (err.message.includes("Failed to fetch")) {
        userMessage = "Network error: Unable to reach server";
      }

      if (err.message.includes("NameResolutionError")) {
        userMessage = "DNS error: Invalid backend URL or region";
      }

      if (err.message.includes("NetworkError")) {
        userMessage = "Network error: Check your internet connection";
      }

      showMessage(userMessage);
    }
  };

  const handleDelete = (appName, version, region) => {
    console.log("AppNAme", appName, region);

    setModalData({
      isOpen: true,
      hideCloseButton: true,
      content: (
        <div className={modalStyles.modalContent}>
          <div className={modalStyles.modalContentWrap}>
            <div className={modalStyles.modalContentIc}>
              <IoTrashBin />
            </div>
            <p className={modalStyles.modalMessage}>
              Are you sure you want to delete app "{appName}"?
            </p>
          </div>
          <div className={modalStyles.modalActions}>
            <button
              className={`${modalStyles.modalButton} ${modalStyles.cancelBtn}`}
              onClick={closeModal}
            >
              No
            </button>
            <button
              className={`${modalStyles.modalButton} ${modalStyles.okBtn}`}
              onClick={() => confirmDelete(appName, version, region)}
            >
              Yes
            </button>
          </div>
        </div>
      ),
      onConfirm: () => confirmDelete(appName, version, region),
    });
  };

  const handleNavigate = (appName) => {
    const url = `/app_detail/${appName}`;
    history.push(url, { activeItemId: "Credentials" });
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const toggleListView = () => {
    dispatch({ type: TOGGLE_VIEW });
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (type === "checkbox") {
      setFormValues((prevValues) => ({
        ...prevValues,
        settings: {
          ...prevValues.settings,
          [name]: checked,
        },
      }));
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredUsers = useMemo(() => {
    if (!users) return null;
    if (!searchTerm.trim()) return users;

    const searchLower = searchTerm.toLowerCase().trim();
    return users.filter((user) => {
      return (
        user.app_name?.toLowerCase().includes(searchLower) ||
        user.app_id?.toLowerCase().includes(searchLower) ||
        user.region?.toLowerCase().includes(searchLower) ||
        user.role?.toLowerCase().includes(searchLower) ||
        user.settings?.version?.toLowerCase().includes(searchLower) ||
        user.settings?.app_type?.toLowerCase().includes(searchLower)
      );
    });
  }, [users, searchTerm]);

  const clearSearch = () => {
    setSearchTerm("");
  };

  if (!users) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <LoaderComp />
      </div>
    );
  } else {
    console.log("user jfdsb", users);

    const tableView = (
      <div>
        {filteredUsers && filteredUsers.length === 0 && searchTerm && (
          <div className={allAppStyle.noSearchResults}>
            <p>No apps found matching "{searchTerm}"</p>
          </div>
        )}
        {filteredUsers && filteredUsers.length > 0 && (
          <table className={allAppStyle.table}>
            <thead>
              <tr>
                <th>Name</th>
                <th>App ID</th>
                <th>Region</th>
                <th>Role</th>
                <th>Timestamp</th>
                <th>Region</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((item, index) => (
                <tr key={index}>
                  <td>{item.app_name}</td>
                  <td>{item.app_id}</td>
                  <td>{item.region}</td>
                  <td>{item.role}</td>
                  <td>{item.timestamp}</td>
                  <td>{item.region.toUpperCase()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );

    const cardView = (
      <div className={allAppStyle.mycard}>
        {filteredUsers && filteredUsers.length === 0 && searchTerm && (
          <div className={allAppStyle.noSearchResults}>
            <p>No apps found matching "{searchTerm}"</p>
          </div>
        )}
        {filteredUsers &&
          filteredUsers.map((user, index) => (
            <div
              className={allAppStyle.firstApp_card}
              data-tour={index === 0 ? "click-on-app" : undefined}
              key={index}
              id={"app" + index}
            >
              <Link
                to={`/app_detail/${user.region}/${encodeURIComponent(user.app_name)}`}
                className={allAppStyle.cardbg}
              >
                <h3>
                  {user.app_name}
                  {user.draft ? (
                    <span className={allAppStyle.draftBadge}>Draft</span>
                  ) : (
                    <span className={allAppStyle.liveBadge}>Live</span>
                  )}
                </h3>
                <div className={allAppStyle.appIds}>
                  <div className={allAppStyle.appType_region}>
                    <div className={allAppStyle.app_id}>
                      <p className={allAppStyle.idHeading}>Region</p>
                      <p>{user.region.toUpperCase()}</p>
                    </div>
                  </div>

                  <div className={allAppStyle.chatTypes}>
                    {/* ============================================================ */}
                    {/* 🤖 AI AGENT - Only show if `ai_agent` feature flag is true */}
                    {/* This is a SEPARATE icon dedicated to the AI Agent feature   */}
                    {/* ============================================================ */}
                    {isFeatureEnabled("ai_agent") && (
                      <div className={allAppStyle.tooltipWrapper}>
                        <button className={allAppStyle.aiBotEnabled}>
                          <img
                            src="/icons/aiAgent.svg"
                            alt="AI Agent Icon"
                            className={allAppStyle.icon}
                          />
                        </button>
                        <span className={allAppStyle.tooltipText}>
                          AI Agent
                        </span>
                      </div>
                    )}

                    {/* ============================================================ */}
                    {/* 🧠 AI Chat Bot - Only show if `qna_bot` feature flag is true */}
                    {/* Training flag is shown ONLY alongside this icon             */}
                    {/* ============================================================ */}
                    {isFeatureEnabled("qna_bot") && (
                      <div className={allAppStyle.tooltipWrapper}>
                        <div
                          className={`${allAppStyle.iconWrapper} ${
                            !user.ai_agent_bot_enabled
                              ? allAppStyle.disabledOverlay
                              : ""
                          }`}
                        >
                          <button
                            className={
                              user.ai_agent_bot_enabled
                                ? allAppStyle.aiBotEnabled
                                : allAppStyle.aiBotDisabled
                            }
                            disabled={!user.ai_agent_bot_enabled}
                          >
                            <img
                              src="/icons/aiChatBot.svg"
                              alt="AI Chat Icon"
                              className={allAppStyle.icon}
                            />
                          </button>
                        </div>
                        <span className={allAppStyle.tooltipText}>
                          AI Chat Bot
                        </span>

                        {/* Training / Trained Label - Only if qna_bot is enabled */}
                        {user.ai_agent_bot_enabled && (
                          <p
                            className={`${allAppStyle.trainingLabel} ${
                              user.draft
                                ? allAppStyle.drafted
                                : user.isTraining === 0
                                ? allAppStyle.untrained
                                : user.isTraining === 1
                                ? allAppStyle.training
                                : user.isTraining === 2
                                ? allAppStyle.trained
                                : user.isTraining === 3
                                ? allAppStyle.error
                                : allAppStyle.unknown
                            }`}
                          >
                            {user.isTraining === 0 && "Untrained"}
                            {user.isTraining === 1 && "Training…"}
                            {user.isTraining === 2 && "Trained"}
                            {user.isTraining === 3 && "Error"}
                            {user.isTraining === 4 && "Unknown"}
                          </p>
                        )}
                      </div>
                    )}

                    {/* 💬 Lead Gen Chat Bot - Only show if `qna_bot` feature flag is true */}
                    {isFeatureEnabled("qna_bot") && (
                      <div className={allAppStyle.tooltipWrapper}>
                        <button
                          className={
                            user.enabled_bot_content
                              ? allAppStyle.aiBotEnabled
                              : allAppStyle.aiBotDisabled
                          }
                          disabled={!user.enabled_bot_content}
                        >
                          <img
                            src="/icons/leadGenChatBot.svg"
                            alt="Lead Gen Chat Icon"
                            className={allAppStyle.icon}
                          />
                        </button>
                        <span className={allAppStyle.tooltipText}>
                          Lead Gen Chat Bot
                        </span>
                      </div>
                    )}

                    {/* 👥 Live User Chat - Only show if `live_chat` feature flag is true */}
                    {isFeatureEnabled("live_chat") && (
                      <div className={allAppStyle.tooltipWrapper}>
                        <button className={allAppStyle.aiBotEnabled}>
                          <img
                            src="/icons/liveUserChatIocn.svg"
                            alt="Live Chat Icon"
                            className={allAppStyle.icon}
                          />
                        </button>
                        <span className={allAppStyle.tooltipText}>
                          Live User Chat
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </Link>

              <div className={allAppStyle.deleteAppIc}>
                <RiDeleteBinLine
                  style={{ color: "red" }}
                  onClick={() =>
                    handleDelete(
                      user.app_name,
                      user.settings?.version,
                      user.region,
                    )
                  }
                />
              </div>
            </div>
          ))}
      </div>
    );

    return (
      <div className={allAppStyle.contents}>
        {users.length > 0 && (
          <div className={allAppStyle.search_adduser}>
            <div className={allAppStyle.searchContainer}>
              <div className={allAppStyle.searchInputWrapper}>
                <input
                  type="search"
                  placeholder="Search apps by name, ID, region, type..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className={allAppStyle.searchInput}
                  data-tour="search-apps"
                />
                <RiSearchLine className={allAppStyle.searchIcon} />
              </div>

              <button
                className={allAppStyle.category}
                onClick={toggleListView}
                data-tour="view-toggle"
              >
                {state.isListView ? <FaList /> : <TbCategory />}
              </button>
            </div>

            <div
              className={allAppStyle.addUser}
              onClick={() => history.push("/create_application")}
              data-tour="create-app"
            >
              <RiAddCircleLine className={allAppStyle.adduserIc} />
              <button className={allAppStyle.userBtn}>Create App</button>
            </div>
          </div>
        )}

        <div className={allAppStyle.all_application}>
          {users.length === 0 ? (
            <div className={allAppStyle.noAppsWrapper}>
              <img
                src="/icons/noApps.svg"
                alt="No apps"
                className={allAppStyle.noAppsIcon}
              />
              <h2>No Apps Found</h2>
              <p>There are no apps yet. Please create an app.</p>

              <button
                className={allAppStyle.userBtn}
                onClick={() => history.push("/create_application")}
              >
                <RiAddCircleLine className={allAppStyle.adduserIc} />
                Create App
              </button>
            </div>
          ) : (
            <>
              {!state.isListView && cardView}
              {state.isListView && (
                <div className={allAppStyle["table-container"]}>
                  {tableView}
                </div>
              )}
            </>
          )}
        </div>

        <ModalReuse
          isOpen={modalData.isOpen}
          onClose={closeModal}
          content={modalData.content}
          hideCloseButton={modalData.hideCloseButton}
        />

        {alertData.isVisible && (
          <AlertPopup
            type={alertData.type}
            message={alertData.message}
            onClose={() =>
              setAlertData((prev) => ({ ...prev, isVisible: false }))
            }
          />
        )}
      </div>
    );
  }
}